import { Injectable } from '@angular/core';
import { Observable, AsyncSubject, Subscription } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';
import { Uploadable } from '@akiba/models_bimbo';


@Injectable()
export class UploadService {

  uploadSubscription: Subscription;
  downloadURL: Observable<string>;
  downloadURLSubject: AsyncSubject<string> = new AsyncSubject();

  constructor(private storage: AngularFireStorage) { }

  pushUpload(upload: Uploadable) {

    if (this.uploadSubscription && !this.uploadSubscription.closed) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }

    const fileRef = this.storage.ref(upload.bucket);
    const task = this.storage.upload(upload.bucket, upload.file);

    this.uploadSubscription = task.snapshotChanges().pipe(finalize(() => {

      let subs = fileRef.getDownloadURL().subscribe(result => {

        if (subs && subs.closed) {
          subs.unsubscribe();
          subs = null;
        }

        if (this.downloadURLSubject && !this.downloadURLSubject.closed) {

          this.downloadURLSubject.next(result);
          this.downloadURLSubject.complete();
          this.downloadURLSubject = new AsyncSubject();

        }


      });
    })).subscribe();

  }

}
